import React, { useEffect, useRef, useState } from "react";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { Paper } from "@material-ui/core";

import Pagination from "@material-ui/lab/Pagination";
import usePagination from "../../../components/usePagination/usePagination";
import ReactToPrint from "react-to-print";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { upperCase } from "lodash";
function LibraryRecords() {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  const [sessionData, setSessionData] = useState([]);
  const [recordData, setRecordData] = useState([]);
  const [searchtext, setsearchtext] = useState("");
  const [yearId, setYearId] = useState("");
  const [addRecordLoading, setAddRecordLoading] = useState(false);

  const [addBookModal, setAddBookModal] = useState(false);
  const [accNo, setAccNo] = useState("");
  const [ddcNo, setDdcNo] = useState("");
  const [bookTitle, setBookTitle] = useState("");
  const [price, setPrice] = useState("");
  const [subject, setSubject] = useState("");
  const [author, setAuthor] = useState("");
  const [authorMark, setAuthorMark] = useState("");
  const [publisher, setPublisher] = useState("");
  const [publicationPlace, setPublicationPlace] = useState("");
  const [edition, setEdition] = useState("");
  const [publicationYear, setPublicationYear] = useState("");
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [binding, setBinding] = useState("");
  const [volume, setVolume] = useState("");
  const [source, setSource] = useState("");

  const [editBookModal, setEditBookModal] = useState(false);
  const [editAccNo, setEditAccNo] = useState("");
  const [editDdcNo, setEditDdcNo] = useState("");
  const [editBookTitle, setEditBookTitle] = useState("");
  const [editPrice, setEditPrice] = useState("");
  const [editSubject, setEditSubject] = useState("");
  const [editAuthor, setEditAuthor] = useState("");
  const [editAuthorMark, setEditAuthorMark] = useState("");
  const [editPublisher, setEditPublisher] = useState("");
  const [editPublicationPlace, setEditPublicationPlace] = useState("");
  const [editEdition, setEditEdition] = useState("");
  const [editPublicationYear, setEditPublicationYear] = useState("");
  const [editDate, setEditDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [editBinding, setEditBinding] = useState("");
  const [editVolume, setEditVolume] = useState("");
  const [editSource, setEditSource] = useState("");
  const [editBookId, setEditBookId] = useState("");

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteBookId, setDeleteBookId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const exportTable = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);

  const pageStyle = `
  @page {
    size:A4 landscape !important;
  }
  `;

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(recordData?.length / PER_PAGE);
  const _DATA = usePagination(recordData, PER_PAGE);

  useEffect(() => {
    getSessions();
    getSettingData();
    getLibraryRecords();
  }, []);

  const getSessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getLibraryRecords = async () => {
    setloading(true);
    await fetch(`${baseUrl}/library-records`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setRecordData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const searchByText = (e) => {
    e.preventDefault();
    if (searchtext === "") {
      return alert.error(
        "Please enter book title or author name or publisher name"
      );
    } else {
      setloading(true);
      const data = {
        search_value: searchtext.toLocaleUpperCase(),
      };

      fetch(`${baseUrl}/search-library-records`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              alert.error("Match not found");
            }
            setRecordData(data.payload);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg[0]);
            });
          }
          setloading(false);
        })
        .catch((err) => {
          console.log("err is re", err);
        });
    }
  };

  const addBookHandler = async () => {
    if (yearId == "" || author == "") {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      year_setting_id: yearId,
      book_title: bookTitle,
      acc_no: accNo,
      ddc_no: ddcNo,
      price: price,
      subject: subject,
      author: author,
      author_mark: authorMark,
      publisher: publisher,
      publication_place: publicationPlace,
      publication_year: publicationYear,
      edition: edition,
      date: date,
      binding: binding,
      volume: volume,
      source: source,
    };
    setAddRecordLoading(true);

    await fetch(`${baseUrl}/library-records`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Book record successfully added");
            setAddBookModal(false);
            setAddRecordLoading(false);
            getLibraryRecords();
            getSessions();
            setBookTitle("");
            setAccNo("");
            setDdcNo("");
            setPrice("");
            setSubject("");
            setAuthor("");
            setAuthorMark("");
            setPublisher("");
            setPublicationPlace("");
            setPublicationYear("");
            setEdition("");
            setDate("");
            setBinding("");
            setVolume("");
            setSource("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddBookModal(false);
            setAddRecordLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddBookModal(false);
            setAddRecordLoading(false);
          }
        })
      )
      .catch((err) => {
        setAddRecordLoading(false);
        setAddBookModal(false);
        console.log(err);
      });
  };

  const getEditBook = async (id) => {
    await fetch(`${baseUrl}/library-records/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditBookTitle(data.payload?.book_title);
          setEditAccNo(data.payload?.acc_no);
          setEditDdcNo(data.payload?.ddc_no);
          setEditPrice(data.payload?.price);
          setEditSubject(data.payload?.subject);
          setEditAuthor(data.payload?.author);
          setEditAuthorMark(data.payload?.author_mark);
          setEditPublisher(data.payload?.publisher);
          setEditPublicationPlace(data.payload?.publication_place);
          setEditPublicationYear(data.payload?.publication_year);
          setEditEdition(data.payload?.edition);
          setEditDate(data.payload?.date);
          setEditBinding(data.payload?.binding);
          setEditVolume(data.payload?.volume);
          setEditSource(data.payload?.source);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateBookHandler = async () => {
    if (yearId == "") {
      return alert.error("Year Is Required");
    }

    if (editAuthor == "") {
      return alert.error("Author Is Required");
    }

    setSubmitLoading(true);
    const data = {
      year_setting_id: yearId,
      book_title: editBookTitle,
      acc_no: editAccNo,
      ddc_no: editDdcNo,
      price: editPrice,
      subject: editSubject,
      author: editAuthor,
      author_mark: editAuthorMark,
      publisher: editPublisher,
      publication_place: editPublicationPlace,
      publication_year: editPublicationYear,
      edition: editEdition,
      date: editDate,
      binding: editBinding,
      volume: editVolume,
      source: editSource,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/library-records/${editBookId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Subject Successfully Updated");
            getLibraryRecords();
            setEditBookModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditBookModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditBookModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteBookHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/library-records/${deleteBookId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getLibraryRecords();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {}, []);

  const todayDate = () => {
    let d = new Date();
    var curr_moth = ("0" + (d.getMonth() + 1)).slice(-2);
    var curr_date = ("0" + d.getDate()).slice(-2);
    let newdate = `${d.getFullYear()}-${curr_moth}-${curr_date}`;
    return newdate;
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddBookModal(true)}
            className="btn btn-primary m-2"
          >
            Add Book
          </button>
        </div>

        <div className="d-flex mt-2">
          <div className="col-md-6 p-2">
            <input
              onChange={(e) => setsearchtext(e.target.value)}
              className="form-control"
              placeholder="Enter Book Title or Author Name or Publisher Name"
            />
          </div>
          <div className="m-2">
            <button className="btn btn-primary" onClick={searchByText}>
              Search
            </button>

            {recordData?.length > 0 ? (
              <ReactToPrint
                documentTitle={`Library Books Record Report`}
                pageStyle={pageStyle}
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    disabled={printloading ? true : false}
                    className="btn btn-primary w-105px mx-2"
                  >
                    {printloading ? <span>Printing..</span> : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
            ) : null}

            <DownloadTableExcel
              filename="Library Books Record Report"
              sheet="Library Books Record Report"
              currentTableRef={exportTable.current}
            >
              {recordData?.length > 0 ? (
                <button className="btn btn-primary mx-2">Export</button>
              ) : null}
            </DownloadTableExcel>
          </div>
        </div>

        <div style={{ overflowY: "auto", overflowX: "auto", width: "100%" }}>
          <Table className="mt-5">
            <thead>
              <tr className="text-center">
                <th>ID</th>
                <th style={{ minWidth: "250px" }}>Author</th>
                <th style={{ minWidth: "250px" }}>Book Title</th>
                <th style={{ minWidth: "200px" }}>Subject</th>
                <th style={{ minWidth: "100px" }}>ACC No.</th>
                <th style={{ minWidth: "100px" }}>DDC No.</th>
                <th style={{ minWidth: "100px" }}>Price</th>
                <th style={{ minWidth: "150px" }}>Author Mark</th>
                <th style={{ minWidth: "250px" }}>Publisher</th>
                <th style={{ minWidth: "100px" }}>Edition</th>
                <th style={{ minWidth: "200px" }}>Publication Place</th>
                <th style={{ minWidth: "200px" }}>Publication Year</th>
                <th style={{ minWidth: "150px" }}>Date</th>
                <th style={{ minWidth: "150px" }}>Binding</th>
                <th style={{ minWidth: "150px" }}>Volume</th>
                <th style={{ minWidth: "150px" }}>Source</th>
                <th>Update</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {_DATA.currentData()?.map((bookData, index) => (
                <tr className="text-center" key={index}>
                  <td>{bookData?.id}</td>
                  <td style={{ minWidth: "250px" }}>
                    {bookData?.author ?? "---"}
                  </td>
                  <td style={{ minWidth: "250px" }}>
                    {bookData?.book_title ?? "---"}
                  </td>
                  <td style={{ minWidth: "200px" }}>
                    {bookData?.subject ?? "---"}
                  </td>
                  <td style={{ minWidth: "100px" }}>
                    {bookData?.acc_no ?? "---"}
                  </td>
                  <td style={{ minWidth: "100px" }}>
                    {bookData?.ddc_no ?? "---"}
                  </td>
                  <td style={{ minWidth: "100px" }}>
                    {bookData?.price ?? "---"}
                  </td>
                  <td style={{ minWidth: "150px" }}>
                    {bookData?.author_mark ?? "---"}
                  </td>
                  <td style={{ minWidth: "250px" }}>
                    {bookData?.publisher ?? "---"}
                  </td>
                  <td style={{ minWidth: "100px" }}>
                    {bookData?.edition ?? "---"}
                  </td>
                  <td style={{ minWidth: "200px" }}>
                    {bookData?.publication_place ?? "---"}
                  </td>
                  <td style={{ minWidth: "200px" }}>
                    {bookData?.publication_year ?? "---"}
                  </td>
                  <td style={{ minWidth: "150px" }}>
                    {bookData?.date ?? "---"}
                  </td>
                  <td style={{ minWidth: "150px" }}>
                    {bookData?.binding ?? "---"}
                  </td>
                  <td style={{ minWidth: "150px" }}>
                    {bookData?.volume ?? "---"}
                  </td>
                  <td style={{ minWidth: "150px" }}>
                    {bookData?.source ?? "---"}
                  </td>
                  <td>
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                      onClick={() => {
                        getEditBook(bookData?.id);
                        setEditBookId(bookData?.id);
                        setEditBookModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Write.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                  <td>
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                      onClick={() => {
                        setDeleteBookId(bookData?.id);
                        setdeleteModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Delete-user.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        <Pagination
          color="primary"
          count={count}
          size="large"
          page={page}
          variant="text"
          shape="round"
          onChange={handleChange}
        />

        {/* Add Books Record Modal */}
        <Modal show={addBookModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add Book Record
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Select Session</b> <span style={{ color: "red" }}>*</span>
                </label>
                <div className="d-flex flex-column ">
                  <select
                    style={{ height: 40 }}
                    className="form-select"
                    name="year_id"
                    value={yearId}
                    aria-label="Default select example"
                    onChange={(e) => setYearId(e.target.value)}
                  >
                    <option value="">Select Session</option>
                    {sessionData &&
                      sessionData.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.year}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>
                    Enter Author <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={author}
                  onChange={(e) => setAuthor(e.target.value)}
                  placeholder="Enter Author"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Book Title</b>
                </label>
                <input
                  className="form-control"
                  value={bookTitle}
                  onChange={(e) => setBookTitle(e.target.value)}
                  placeholder="Enter Book Title"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Subject</b>
                </label>
                <input
                  className="form-control"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  placeholder="Enter Subject"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter ACC No.</b>
                </label>
                <input
                  className="form-control"
                  value={accNo}
                  onChange={(e) => setAccNo(e.target.value)}
                  placeholder="Enter ACC No."
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter DDC No.</b>
                </label>
                <input
                  className="form-control"
                  value={ddcNo}
                  onChange={(e) => setDdcNo(e.target.value)}
                  placeholder="Enter DDC No."
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Price</b>
                </label>
                <input
                  className="form-control"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  placeholder="Enter Price"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Author Mark</b>
                </label>
                <input
                  className="form-control"
                  value={authorMark}
                  onChange={(e) => setAuthorMark(e.target.value)}
                  placeholder="Enter Author Mark"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Publisher</b>
                </label>
                <input
                  className="form-control"
                  value={publisher}
                  onChange={(e) => setPublisher(e.target.value)}
                  placeholder="Enter Publisher"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Publication Place</b>
                </label>
                <input
                  className="form-control"
                  value={publicationPlace}
                  onChange={(e) => setPublicationPlace(e.target.value)}
                  placeholder="Enter Publication Place"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Publication Year </b>
                </label>
                <input
                  className="form-control"
                  value={publicationYear}
                  onChange={(e) => setPublicationYear(e.target.value)}
                  placeholder="Enter Publication Year"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Edition</b>
                </label>
                <input
                  className="form-control"
                  value={edition}
                  onChange={(e) => setEdition(e.target.value)}
                  placeholder="Enter edition"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Select Date</b>
                </label>
                <input
                  className="form-control"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  type="date"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Binding</b>
                </label>
                <input
                  className="form-control"
                  value={binding}
                  onChange={(e) => setBinding(e.target.value)}
                  placeholder="Enter Binding"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Volume</b>
                </label>
                <input
                  className="form-control"
                  value={volume}
                  onChange={(e) => setVolume(e.target.value)}
                  placeholder="Enter Volume"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Source</b>
                </label>
                <input
                  className="form-control"
                  value={source}
                  onChange={(e) => setSource(e.target.value)}
                  placeholder="Enter Source"
                />
              </div>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addRecordLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addBookHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddBookModal(false);
                setisallfields(false);
                getSessions();
                setBookTitle("");
                setAccNo("");
                setDdcNo("");
                setPrice("");
                setSubject("");
                setAuthor("");
                setAuthorMark("");
                setPublisher("");
                setPublicationPlace("");
                setPublicationYear("");
                setEdition("");
                setDate("");
                setBinding("");
                setVolume("");
                setSource("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update SubjectModal */}
        <Modal show={editBookModal} size="lg">
          <Modal.Header>
            <Modal.Title>Update Book Record</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Select Session</b> <span style={{ color: "red" }}>*</span>
                </label>
                <div className="d-flex flex-column ">
                  <select
                    style={{ height: 40 }}
                    className="form-select"
                    name="year_id"
                    value={yearId}
                    aria-label="Default select example"
                    onChange={(e) => setYearId(e.target.value)}
                  >
                    <option value="">Select Session</option>
                    {sessionData &&
                      sessionData.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.year}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>
                    Enter Author <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editAuthor}
                  onChange={(e) => setEditAuthor(e.target.value)}
                  placeholder="Enter Author"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Book Title</b>
                </label>
                <input
                  className="form-control"
                  value={editBookTitle}
                  onChange={(e) => setEditBookTitle(e.target.value)}
                  placeholder="Enter Book Title"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Subject</b>
                </label>
                <input
                  className="form-control"
                  value={editSubject}
                  onChange={(e) => setEditSubject(e.target.value)}
                  placeholder="Enter Subject"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter ACC No.</b>
                </label>
                <input
                  className="form-control"
                  value={editAccNo}
                  onChange={(e) => setEditAccNo(e.target.value)}
                  placeholder="Enter ACC No."
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter DDC No.</b>
                </label>
                <input
                  className="form-control"
                  value={editDdcNo}
                  onChange={(e) => setEditDdcNo(e.target.value)}
                  placeholder="Enter DDC No."
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Price</b>
                </label>
                <input
                  className="form-control"
                  value={editPrice}
                  onChange={(e) => setEditPrice(e.target.value)}
                  placeholder="Enter Price"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Author Mark</b>
                </label>
                <input
                  className="form-control"
                  value={editAuthorMark}
                  onChange={(e) => setEditAuthorMark(e.target.value)}
                  placeholder="Enter Author Mark"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Publisher</b>
                </label>
                <input
                  className="form-control"
                  value={editPublisher}
                  onChange={(e) => setEditPublisher(e.target.value)}
                  placeholder="Enter Publisher"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Publication Place</b>
                </label>
                <input
                  className="form-control"
                  value={editPublicationPlace}
                  onChange={(e) => setEditPublicationPlace(e.target.value)}
                  placeholder="Enter Publication Place"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Publication Year</b>
                </label>
                <input
                  className="form-control"
                  value={editPublicationYear}
                  onChange={(e) => setEditPublicationYear(e.target.value)}
                  placeholder="Enter Publication Year"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Edition</b>
                </label>
                <input
                  className="form-control"
                  value={editEdition}
                  onChange={(e) => setEditEdition(e.target.value)}
                  placeholder="Enter edition"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Select Date</b>
                </label>
                <input
                  className="form-control"
                  value={editDate}
                  onChange={(e) => setEditDate(e.target.value)}
                  type="date"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Binding</b>
                </label>
                <input
                  className="form-control"
                  value={editBinding}
                  onChange={(e) => setEditBinding(e.target.value)}
                  placeholder="Enter Binding"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Volume</b>
                </label>
                <input
                  className="form-control"
                  value={editVolume}
                  onChange={(e) => setEditVolume(e.target.value)}
                  placeholder="Enter Volume"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Enter Source</b>
                </label>
                <input
                  className="form-control"
                  value={editSource}
                  onChange={(e) => setEditSource(e.target.value)}
                  placeholder="Enter Source"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button onClick={updateBookHandler} className="btn btn-primary">
                Update
              </button>
            )}

            <button
              onClick={() => setEditBookModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete  Subject Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this subject?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Fee Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button onClick={deleteBookHandle} className="btn button_blue">
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>

        {/* for print  */}
        <div
          ref={componentRef}
          id="printSection"
          className="customTablePrint"
        >
          <div className="p-3" style={{ display: "flex" }}>
            <img style={{ height: 120, width: 130 }} src={icon} alt="icon" />

            <div className="row ml-4">
              <h1>{unitName}</h1>
              <h3>Library Books Record Report</h3>
              <h5 className="ffonmt">Printing Date :- {todayDate()}</h5>
            </div>
          </div>

          <Table>
            <thead>
              <tr className="text-center">
                <th>ID</th>
                <th>Author</th>
                <th>Book Title</th>
                <th>Subject</th>
                <th>ACC No.</th>
                <th>DDC No.</th>
                <th>Price</th>
                <th>Author Mark</th>
                <th>Publisher</th>
                <th>Edition</th>
                <th>Publication Place</th>
                <th>Publication Year</th>
                <th>Date</th>
                <th>Binding</th>
                <th>Volume</th>
                <th>Source</th>
              </tr>
            </thead>
            <tbody>
              {recordData?.map((bookData, index) => (
                <tr className="text-center" key={index}>
                  <td>{bookData?.id}</td>
                  <td>{bookData?.author ?? "---"}</td>
                  <td>{bookData?.book_title ?? "---"}</td>
                  <td>{bookData?.subject ?? "---"}</td>
                  <td>{bookData?.acc_no ?? "---"}</td>
                  <td>{bookData?.ddc_no ?? "---"}</td>
                  <td>{bookData?.price ?? "---"}</td>
                  <td>{bookData?.author_mark ?? "---"}</td>
                  <td>{bookData?.publisher ?? "---"}</td>
                  <td>{bookData?.edition ?? "---"}</td>
                  <td>{bookData?.publication_place ?? "---"}</td>
                  <td>{bookData?.publication_year ?? "---"}</td>
                  <td>{bookData?.date ?? "---"}</td>
                  <td>{bookData?.binding ?? "---"}</td>
                  <td>{bookData?.volume ?? "---"}</td>
                  <td>{bookData?.source ?? "---"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* for exprot print */}
        <div ref={exportTable} id="printSection" className="customTablePrint">
          <div id="tableboot">
            <div className="p-3" style={{ display: "flex" }}>
              <h1>{unitName}</h1>
              <h3>Library Books Record Report</h3>
              <h5 className="ffonmt">Printing Date :- {todayDate()}</h5>
            </div>

            <Table>
              <thead>
                <tr className="text-center">
                  <th>ID</th>
                  <th>Author</th>
                  <th>Book Title</th>
                  <th>Subject</th>
                  <th>ACC No.</th>
                  <th>DDC No.</th>
                  <th>Price</th>
                  <th>Author Mark</th>
                  <th>Publisher</th>
                  <th>Edition</th>
                  <th>Publication Place</th>
                  <th>Publication Year</th>
                  <th>Date</th>
                  <th>Binding</th>
                  <th>Volume</th>
                  <th>Source</th>
                </tr>
              </thead>
              <tbody>
                {recordData?.map((bookData, index) => (
                  <tr className="text-center" key={index}>
                    <td>{bookData?.id}</td>
                    <td>{bookData?.acc_no ?? "---"}</td>
                    <td>{bookData?.ddc_no ?? "---"}</td>
                    <td>{bookData?.book_title ?? "---"}</td>
                    <td>{bookData?.price ?? "---"}</td>
                    <td>{bookData?.subject ?? "---"}</td>
                    <td>{bookData?.author ?? "---"}</td>
                    <td>{bookData?.author_mark ?? "---"}</td>
                    <td>{bookData?.publisher ?? "---"}</td>
                    <td>{bookData?.edition ?? "---"}</td>
                    <td>{bookData?.publication_place ?? "---"}</td>
                    <td>{bookData?.publication_year ?? "---"}</td>
                    <td>{bookData?.date ?? "---"}</td>
                    <td>{bookData?.binding ?? "---"}</td>
                    <td>{bookData?.volume ?? "---"}</td>
                    <td>{bookData?.source ?? "---"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </Paper>
    </div>
  );
}

export default LibraryRecords;
